// Rendez-vous, vus de l’application : accepter ou refuser une demande en attente de validation.
export interface RespondResult {
  ok: boolean;
  status: 'confirmed' | 'declined';
  meetUrl?: string | null;
  invited?: boolean;
}

let tokenProvider: () => Promise<string | null> = async () => null;

/** Fournit le jeton de session Supabase aux appels serveur. */
export function setRdvTokenProvider(fn: () => Promise<string | null>): void {
  tokenProvider = fn;
}

export async function respondBooking(id: string, action: 'approve' | 'decline'): Promise<RespondResult> {
  const token = await tokenProvider();
  const res = await fetch('/api/rdv/respond', {
    method: 'POST',
    headers: { 'content-type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ id, action }),
  });
  let data: RespondResult & { error?: string; message?: string };
  try { data = (await res.json()) as typeof data; }
  catch { throw new Error(`Le serveur n’a pas répondu correctement (HTTP ${res.status}).`); }
  if (!res.ok) throw new Error(data.message ?? `Erreur serveur (HTTP ${res.status}).`);
  return data;
}
